module.exports = {
      id: "newslettericon-usage",
      viewBox: "0 0 48 47.861",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#newslettericon",
      toString: function () {
        return this.url;
      }
    }